import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LabOrderValidationError } from '../../../api/lab-order/model/labOrderValidationError';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private readonly messages = new Subject<{
    text: string;
    type: string;
    errors?: LabOrderValidationError[];
  } | null>();

  public messages$ = this.messages.asObservable();

  public pushError(
    errorMessage?: string,
    errors?: LabOrderValidationError[]
  ): void {
    if (errorMessage) {
      this.messages.next({ text: errorMessage, type: 'error', errors: errors });
    } else {
      this.messages.next({
        text: 'Something went wrong, please try again later.',
        type: 'error',
      });
    }
    this.scrollToTop();
  }

  public pushWarning(errorMessage: string): void {
    this.messages.next({ text: errorMessage, type: 'warning' });
    this.scrollToTop();
  }

  public pushInfo(errorMessage: string): void {
    this.messages.next({ text: errorMessage, type: 'info' });
    this.scrollToTop();
  }

  public pushSuccess(errorMessage: string): void {
    this.messages.next({ text: errorMessage, type: 'success' });
    this.scrollToTop();
  }

  public clearMessages(): void {
    this.messages.next(null);
  }

  private scrollToTop(): void {
    window.scroll(0, 0);
  }
}
